import { render, staticRenderFns } from "./SampleTwo.vue?vue&type=template&id=120989bb&scoped=true&"
import script from "./SampleTwo.vue?vue&type=script&lang=js&"
export * from "./SampleTwo.vue?vue&type=script&lang=js&"
import style0 from "./SampleTwo.vue?vue&type=style&index=0&id=120989bb&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120989bb",
  null
  
)

export default component.exports